<template lang="pug">
	el-row#main-footer
		el-col(:span="24")
			p © 2018 - PRA - Programa de Regularização Ambiental
</template>

<script>
export default {
	name: 'MainFooter'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/MainFooter.vue